import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import { a } from "./_csAbt";

import * as BoxC from './_ccbBoxC';
import * as BtnC from './_cccBtnC';
import * as BtnTopC from './_ccmBtnTopC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";

import * as ihd from 'src/ihd';
import * as ica from 'src/ica';

import * as _cv_50 from './_cv_50___Mz';

let $_50rs = [] as ht.ls;

let $ctgs = [] as ht.ls;

const $schz = {
  _50rc1100s: ``, // category
  _50r_pfx: ``,
};

const $loadAsync = async (pz?: {
  frcUdt?: () => void,
  schz?: {
    _50r_pfx?: ht.s,
    _50rc1100s?: ht.s,
  }
}) => {
  let _cdn = f.vdd(false, false);
  if (hf.f(pz?.schz?._50r_pfx)) 
    _cdn += ` AND (_pfx LIKE '%${pz?.schz?._50r_pfx}%' OR _50rc1100s LIKE '%${pz?.schz?._50r_pfx}%')`;
  if (hf.f(pz?.schz?._50rc1100s) && pz?.schz?._50rc1100s != 'すべて') 
    _cdn += ` AND _50rc1100s = '${pz?.schz?._50rc1100s}'`;
  //hf.l(`_cv_51a 32: ${_cdn}`);
  await _cv_50.load_50rLsAsync({
    cdn: _cdn,
  })
  .then((_ls: ht.ls) => {
    //hf.l(`_cv_51a 48: ${hf.s(_ls)}`);
    $_50rs = _ls;
  });
  if (pz?.frcUdt) {
    //hf.l(`_cv_51a 52: here`);
    pz?.frcUdt();
  }
} 

export const B = (pz: ht.btnTopCz) => {
  return (
    cr.c(BtnTopC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        bCrt: false,
      }
    })
  )
};

export const S = (pz: ht.viewListCz) => {

  React.useEffect(() => {
    _cv_50.load_50rc1100sLsAsync() // 設定分類
    .then((_ls: ht.ls) => {
      //hf.l(`Iccv09b1 37: ${hf.s(_ls)}`);
      $ctgs = [{
        key: 'すべて',
        pfx: 'すべて'
      }].concat(_ls);
    });
  }, []);

  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a(`fd/rcc`),
      oClds: [
        cr.c(LblC.N, {
          key: -10,
          abtType: 'ftnCmnz',
          boxStlz: a('dw/30'),
          lblCz: {
            boxStlz: a('dw/8'),
            textz: {
              pfx: '設定分類',
            }
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                abtType: 'ftnCmnz',
                cz: {
                  bEdit: true,
                  iptType: 'pcr',
                  ls: $ctgs,
                  vle: $schz._50rc1100s,
                  onChg: (_dz: ht.dz) => {
                    $schz._50rc1100s = _dz.key;
                  }
                },
              })
            ]
          },
        }),
        cr.c(LblC.N, {
          key: -20,
          abtType: 'ftnCmnz',
          boxStlz: a('dw/30'),
          lblCz: {
            boxStlz: a('dw/8'),
            textz: {
              pfx: '設定項目',
            }
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                abtType: 'ftnCmnz',
                cz: {
                  bEdit: true,
                  iptType: 'text',
                  vle: $schz._50r_pfx,
                  onChg: (_s: ht.s) => {
                    $schz._50r_pfx = _s;
                  }
                },
              })
            ]
          },
        }),
        cr.c(BtnC.N, {
          key: -30,
          abtType: 'schCmnz',
          lblCz: {
          },
          bfrIconCz: {
          },
          pslPtyz: {
            onPress: () => {
              $loadAsync({
//                frcUdt: pz.sPz.crt.frcUdt,
                frcUdt: pz.sPz.udt,
//                frcUdt: _gUserz.crt.frcUdt,
                schz: $schz,
              })
            }
          }
        })
      ]
    })
  );
};

export const L = (pz: ht.viewListCz) => {

//  const _frcUdt = l.frcUdt();
 
  React.useEffect(() => {
    f.loadAllAsync({
//      frcUdt: _frcUdt,
//      frcUdt: pz.sPz.crt.frcUdt,
      frcUdt: pz.sPz.udt,
//      frcUdt: _gUserz.crt.frcUdt,
      bfrAsync: () => [
/*
        _cv_51.load_50rLsAsync()
        .then((_ls: ht.ls) => {
          $_50rs = _ls
        })
*/
        $loadAsync()
      ]
    });
  }, []);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewListAbtz[_abtType] ? ica.viewListAbtz[_abtType]() : {};

  const _hdrs = [];
  const _cellCs = [
    {
      boxStlz: a('f/0.5'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: 'ID',
          }
        })
      ]
    },
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '設定項目名'
          }
        })
      ]
    },
    {
      boxStlz: a('f/0.5'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '設定分類'
          }
        })
      ]
    },
    {
      boxStlz: a('f/0.5'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '適用範囲'
          }
        })
      ]
    },
    {
      boxStlz: a('dw/btn f/n'),
      oClds: [
      ]
    },
  ];
  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  const _rows = [] as ht.ls;
  $_50rs?.map( ( _dz: ht.dz ) => {
    const _cellCs = [
      {
        boxStlz: a(`f/0.5 fd/rsc`),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.bdyCz.textCz,
            textz: {
              pfx: _dz._icn,
            }
          })
        ]
      },
      {
        boxStlz: a(`fd/rsc`),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.bdyCz.textCz,
            textz: {
              pfx: _dz._pfx,
              ptyz: a(`tn/1`),
            }
          })
        ]
      },
      {
        boxStlz: a(`f/0.5 fd/rsc`),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.bdyCz.textCz,
            textz: {
              pfx: _dz._50rc1100s,
            }
          })
        ]
      },
      {
        boxStlz: a(`f/0.5 fd/rsc`),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.bdyCz.textCz,
            textz: {
              pfx: ihd.r(ihd.f('_50rt2100i').ls, _dz._50rt2100i ?? 10),
            }
          })
        ]
      },
      {
        boxStlz: a('dw/btn f/n'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            ... _abtz.bdyCz.btnCz,
            lblCz: {},
            pslPtyz: {
              onPress: () => {
                //hf.l(`_cv_51___Mz 288: ${hf.s(_dz)}`)
                pz.sPz.set({
                  steps: [1],
                  phs: 'dpy',
                  _50r_icn: _dz._icn,
//                  _50r_fst: _dz._fst, // history に必要
                })
              }
            },
          })
        ]
      },
    ];
    _rows.push(
      {
        cellCs: _cellCs
      },
    )
  });

  //hf.l(`_cv_51a 292: here`);
  return (
    cr.c(TblC.N, {
      key: -30,
      ... _abtz.tblCz,
      srlCz: {
        srlStlz: {
          otrz: a('dwx/100'),
        },
      },
      hdrCz: {
        lineCs: _hdrs,
      },
      bdyCz: {
        lineCs: _rows,
      },
    })
  );
};

